import Placeholder from './Placeholder.vue';
import withInstall from '@/shared/withInstall';

export const XPlaceholder = withInstall(Placeholder);
export default XPlaceholder;
